// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';

type Props = {
  iconSrc: string,
  iconAlt?: string,
};

export function DisplayBrand({ iconSrc, iconAlt }: Props): Node {
  return (
    <Root>
      <IconWrapper>
        <Icon src={iconSrc} alt={iconAlt} />
      </IconWrapper>
    </Root>
  );
}

const Root = styled.div`
  height: 100%;
  display: flex;
`;

const IconWrapper = styled.div`
  flex-grow: 1;
  padding-left: 4px;
`;

const Icon = styled.img`
  height: 20px;
  width: auto;
`;
